import { useMutation } from "@tanstack/react-query";
import { ValidarMatriculaAbogado } from "../services/ValidarMatricula.service";

/**
 * Hook para validar matrícula de abogado
 */
export const useValidarMatricula = () => {
  return useMutation({
    mutationFn: ValidarMatriculaAbogado,
  });
};